// @ts-nocheck
export async function fetchData(url: string): Promise<any> {
    const response = await fetch(url);
    const data = await response.json();
    return data;
}

export function isEmpty(obj) {
    if (obj && typeof obj === 'object') {
        return Object.keys(obj).length === 0;
    }
    return true;
}
